import { client } from "../../client";

export const getWrapNoteTypes = (key: string) => {
  return client
    .get("accounts/wrapupnotes/types")
    .then((response) => response.data);
};

export interface CreateWrapUpNoteDetails {
  subCategory: string;
  contactType: string;
  query?: string;
  response?: string;
  summary: string;
  raisedDttm: string;
  createdDttm: string;
  createdStartDttm: string;
  isOpen: boolean;
}

export const WRAPUPNOTE_STATUSES = [
  "Open",
  "ClosedOneDay",
  "ClosedTwoDay",
  "ClosedMultiDay",
];
export type WrapUpNoteStatus = typeof WRAPUPNOTE_STATUSES[number];

export interface WrapUpNoteDetails {
  id: string;
  category: string;
  subcategory: string;
  contactType: string;
  status: WrapUpNoteStatus;
  createdDttm: string;
  user: string;
  summary: string | null;
  query: string | null;
  response: string | null;
}

interface CreateWrapNoteParams {
  details: Record<string, any>;
  accountNumber: string | number;
  startTime: number;
}
type createWrapNoteFn = (params: CreateWrapNoteParams) => Promise<number>;

export const createWrapUpNote: createWrapNoteFn = ({
  details,
  accountNumber,
  startTime,
}) => {
  const createTime = new Date().toISOString();
  const requestBody: CreateWrapUpNoteDetails = {
    subCategory: details.subcategory,
    contactType: details.contactType,
    summary: details?.summary,
    query: details?.query,
    response: details?.response,
    raisedDttm: createTime,
    createdDttm: createTime,
    createdStartDttm: new Date(startTime).toISOString(),
    isOpen: details.status,
  };
  return client
    .post(`accounts/${accountNumber}/wrapupnotes`, requestBody)
    .then((response) => response.status);
};

export const getWrapUpNoteDetails = (
  querykey: string,
  {
    accountNumber,
    wrapUpNoteId,
  }: { accountNumber: string; wrapUpNoteId: string },
) => {
  return client
    .get<WrapUpNoteDetails>(
      `accounts/${accountNumber}/wrapupnotes/${wrapUpNoteId}`,
    )
    .then((res) => {
      return res.data;
    });
};
